import sendJson from 'utils/fetch-send';
import { getProjectIdFromToken } from 'utils';

import config from 'config';
const { INDEXER_API } = config;

import {
  getQueryProjectsByProjectIds,
  getQueryActivityById,
  getQueryValidationsById,
  subProjectsRequestBody
} from 'services/indexer/elastic-queries';

export default {
  listProjects: (allProjects) => {
    return sendJson(
      'POST',
      `${INDEXER_API}/projects`,
      getQueryProjectsByProjectIds(allProjects.map((p) => getProjectIdFromToken(p[0])))
    );
  },
  listActivities: ({ accountId, page = 1, type, date }) => {
    return sendJson(
      'POST',
      `${INDEXER_API}/user_activity`,
      getQueryActivityById(accountId, type, date, page)
    );
  },
  listValidations: (accountId, from, limit) => {
    return sendJson(
      'POST',
      `${INDEXER_API}/vote_history`,
      getQueryValidationsById(accountId, from, limit)
    );
  },
  listSubProjects: (projectsIds) => {
    return sendJson(
      'POST',
      `${INDEXER_API}/projects`,
      subProjectsRequestBody(projectsIds)
    );
  }
};
